$(document).ready(function () {
  $('.carousel[data-interval]').each(function () {
    $(this).carousel({interval: $(this).data('interval')});
  });
});